import React from 'react';
import Box from '@mui/material/Box';

const PageWrapper = ({ children, sx = {} }) => {
  return (
    <Box sx={{ px: 3, py: 2, ...sx }}>
      {children}
    </Box>
  );
};

export default PageWrapper;
